import dynamic from "next/dynamic";
import { useCallback, useEffect, useState } from "react";
import styles from "./topic.module.scss";

const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
// const Pagination = dynamic(() => import("@/component/Pagination"));
const List1 = dynamic(() => import("@/component/Listing/TopicList"));
const List2 = dynamic(() => import("@/component/Listing/List2"));
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
import { useRouter } from "next/router";
//import Link from "next/link";
import { getDataFromSSR } from "@/handlers/client/commonClient";
import { useInView } from "react-intersection-observer";
import { useWindowSize } from "@/hooks/useIsMobile";
import GTMScript from "@/component/Ads/GTMScript";
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
// const VDOAdsScript = dynamic(() => import("@/component/Ads/VDOAdsScript"));
// const VDOAdSlot = dynamic(() => import("@/component/Ads/VDOAdSlot"));
const NoData = dynamic(() => import("@/component/NoData"));
import { apstagBidCallback, createApsSlotsRosDesktop, createApsSlotsRosMobile, requestBiddingFromPWT } from "@/utils/ads";

const TopicDetail = ({ topicDetailData, isMobileDevice = false }) => {
  const [currentPage, setCurrentPage] = useState(0);
  // const totalPages = topicDetailData?.pagination_cap || 10;
  const [topicData, setTopicData] = useState(
    topicDetailData?.content ? topicDetailData?.content : []
  );
  const [hasMore, setHasMore] = useState(true);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [y, setY] = useState(
    typeof window !== "undefined" && document.scrollingElement.scrollHeight
  );
  const [scrollDirection, setScrollDirection] = useState(
    "you have not scrolled yet"
  );
  // const totalPages = categoryNewsListData?.pagination_cap
  //   ? parseInt(categoryNewsListData?.pagination_cap)
  //   : 10;
  const router = useRouter();

  // const handlePageClick = (page) => {
  //   if (currentPage === page) return;
  //   setCurrentPage(page);
  //   let currentPath = router?.asPath?.split("?")[0];
  //   window.location.href = `${currentPath}?page=${page}`;
  // };

  const [insightref, insightView] = useInView({
    threshold: 0,
    rootMargin: "40%",
  });
  const [mobileInsightref, mobInsightView] = useInView({
    threshold: 0,
    rootMargin: "40%",
  });

  const getMorePost = async () => {
    const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
    setLoadingSpinner(true);
    const fetchedData = await getDataFromSSR(
      `${websiteUrl}/api/getTopicList?page=${currentPage}&slug=${router?.query?.slug}`
    );
    if (fetchedData?.data?.topicDetailData?.content?.length > 0) {
      setTopicData([
        ...topicData,
        ...fetchedData?.data?.topicDetailData?.content,
      ]);
    } else {
      setHasMore(false);
    }
    setLoadingSpinner(false);
  };
  const handleNavigation = useCallback(
    (e) => {
      if (y > window.scrollY) {
        setScrollDirection("Scrolling Up");
      } else if (y < window.scrollY) {
        setScrollDirection("Scrolling Down");
      }
      setY(window.scrollY);
    },
    [y]
  );
  useEffect(() => {
    window.addEventListener("scroll", handleNavigation);

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);

  useEffect(() => {
    if (
      (insightView || mobInsightView) &&
      scrollDirection == "Scrolling Down" &&
      hasMore
    ) {
      setCurrentPage(currentPage + 1);
    }
  }, [insightView, mobInsightView, scrollDirection]);
  useEffect(() => {
    currentPage > 0 && getMorePost();
    let height = window?.scrollY;
    window.scrollTo(0, height);
  }, [currentPage]);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    function handleScroll() {
      if (!scrolled) {
        setScrolled(true);
      }
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          if (!scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1659434453897-0"
              )
              .addService(googletag.pubads());
            document.getElementById("div-gpt-ad-1659434604998-0") && googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF_300x250",
                [300, 250],
                "div-gpt-ad-1659434604998-0"
              )
              .addService(googletag.pubads());
          }
          {
            scrolled && document.getElementById("div-gpt-ad-1659434785315-0") &&
              topicData?.length > 8 &&
              googletag
                .defineSlot(
                  "/1007232/News_tak_Mobile_ROS_MTF-1_300x250",
                  [300, 250],
                  "div-gpt-ad-1659434785315-0"
                )
                .addService(googletag.pubads());
          }
          scrolled && googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_BTF_300x250",
              [300, 250],
              "div-gpt-ad-1659435474737-0"
            )
            .addService(googletag.pubads());
          !scrolled && googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
              [320, 50],
              "div-gpt-ad-1659435612077-0"
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();

          !scrolled && googletag.cmd.push(function () {
            var INTERSTITIALAd = googletag
              .defineOutOfPageSlot(
                "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                googletag.enums.OutOfPageFormat.INTERSTITIAL
              )
              .addService(googletag.pubads());

            INTERSTITIALAd && googletag.display(INTERSTITIALAd);
          });
        });
      } else {
        googletag.cmd.push(function () {
          if (!scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1659424515060-0"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1707804176041-1"
              )
              .addService(googletag.pubads());
          }
          // rhs mtf
          scrolled && document.getElementById("div-gpt-ad-1751005897683-0") && googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_HP_MTF_300x250",
              [300, 250],
              "div-gpt-ad-1751005897683-0"
            )
            .addService(googletag.pubads());
          // rhs btf
          scrolled && document.getElementById("div-gpt-ad-1751005897683-1") && googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_HP_BTF_300x250",
              [300, 250],
              "div-gpt-ad-1751005897683-1"
            )
            .addService(googletag.pubads());
          {
            document.getElementById("div-gpt-ad-1707804176041-2") &&
              topicData?.length > 7 &&
              scrolled && googletag
                .defineSlot(
                  "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                  [728, 90],
                  "div-gpt-ad-1707804176041-2"
                )
                .addService(googletag.pubads());
          }
          scrolled && googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_BTF_728x90",
              [728, 90],
              "div-gpt-ad-1707804176041-3"
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
        });
      }
      apstag?.fetchBids(
        {
          slots:
            window.screen.width < 900
              ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
              : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
          timeout: 2e3,
        },
        apstagBidCallback
      );
    }, 10);

    try {
      // page query params
      const page = parseInt(router?.query?.page);
      if (page) {
        setCurrentPage(parseInt(page));
      }
    } catch (error) {
      console.error(error);
    }
  }, [scrolled]);

  function capitalizeWords(str) {
    return str
      ?.split(" ")
      ?.map(
        (word) => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
      )
      ?.join(" ");
  }

  const size = useWindowSize();
  let englishTitle = topicDetailData?.seo_detail?.canonical_url
    ?.replace("/topic/", "")
    ?.replace("-", " ");
  if (englishTitle) {
    englishTitle = capitalizeWords(englishTitle);
  }
  // console.log("topicDetailData", topicDetailData);
  return (
    <section>
      <HeadTag
        title={`${englishTitle} - Latest News, Photos, Videos on NewsTak`}
        description={`Find ${englishTitle} Latest News, Videos & Pictures on ${englishTitle} and see latest updates, news, information from NewsTak. Explore more on ${englishTitle}`}
        image={topicDetailData?.seo_detail?.og_image}
        keywords={topicDetailData?.seo_detail?.meta_keyword}
        canonicalUrl={
          process.env.NEXT_PUBLIC_WEBSITE_URL +
          topicDetailData?.seo_detail?.canonical_url
        }
      // lcpImage={topicDetailData?.profile_image}
      />
      <GTMScript />
      <BreadcrumbSchema
        breadcrumbList={[
          {
            title: "टॉपिक",
            canonical_url: "/topics",
          },
          {
            title: `${topicDetailData?.title}`,
            canonical_url: `${topicDetailData?.seo_detail?.canonical_url}`,
          },
        ]}
      />
      {/* <VDOAdsScript /> */}
      <Breadcrumb
        breadcrumbList={[
          {
            title: "टॉपिक",
            canonical_url: "/topics",
            icon: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/topic.svg",
          },
          {
            title: `${topicDetailData?.profile_detail?.title}`,
            canonical_url: `${topicDetailData?.profile_detail?.canonical_url}`,
            // icon: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/world.svg",
          },
        ]}
      />

      <header className="my-4 mx-2">
        <div className="text-primary font-bold text-2xl p-2">
          <a
            href={`${topicDetailData?.profile_detail?.canonical_url ?? ""}`}
          >
            <h1>{topicDetailData?.profile_detail?.title}</h1>
          </a>
        </div>
        <div className="flex items-center justify-center px-4 sm:px-6 lg:px-8 py-2 sm:flex-row flex-col text-center sm:text-left bg-[#f7f7f7] rounded-md ">
          <div className="w-20 h-20 mr-3 my-2 md:my-0">
            <a
              href={`${topicDetailData?.profile_detail?.canonical_url ?? ""}`}
            >
              <img
                src={topicDetailData?.profile_detail?.profile_image ?
                  topicDetailData?.profile_detail?.profile_image +
                  "?size=84:84" :
                  "https://cdn-icons-png.flaticon.com/512/847/847969.png"
                }
                loading="lazy"
                alt="Profile"
                className="rounded-full hidden object-cover mb:block xs:block   border-2 p-1 border-primary"
              />
            </a>
          </div>
          <div className="flex items-center w-full md:w-[85%] ">
            
            <div className="ml-4 md:ml-3 xs:ml-0 flex flex-col justify-center">
              {topicDetailData?.profile_detail?.description && (
                <div
                  className={`text-sm text-gray-500  mt-0 md:mt-2 ml-2 text-justify ${styles.topicDetail}`}
                  dangerouslySetInnerHTML={{
                    __html: topicDetailData?.profile_detail?.description,
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </header>

      <section className="mx-4 md:mx-4 md:px-2 py-2">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />

        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="720px"
          minHeight="90px"
        />

        {/* <VDOAdSlot /> */}
        <div className="hidden mb-block md:block lg:block">
          {size.width > 900 && (
            <List2 title={null} newsListData={topicData} showAds={true} scrolled={scrolled} />
          )}
          <div
            className="text-sports news-load h-[50px] w-full mb-4"
            ref={insightref}
          >
            {loadingSpinner === true && (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
              </div>
            )}
          </div>
        </div>
        <div className="hidden md:hidden lg:hidden sm:block mb:block xs:block md-hidden">
          {size.width < 900 && <List1 title={null} newsListData={topicData} showAds={true} scrolled={scrolled} />}
          <div
            className="text-sports news-load h-[50px] w-full mb-4"
            ref={mobileInsightref}
          >
            {loadingSpinner === true && (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
              </div>
            )}
          </div>
        </div>
        {topicData?.length === 0 && topicDetailData?.content?.length === 0 && (
          <NoData message="No Posts yet" />
        )}

        {scrolled && <AdSlot300x250
          divId="div-gpt-ad-1659435474737-0"
          minWidth="300px"
          minHeight="250px"
        />}

        {scrolled && <AdSlot728x90
          divId="div-gpt-ad-1707804176041-3"
          minWidth="720px"
          minHeight="90px"
        />}
        {/* Pagination */}
        {/* <Pagination
          handlePageClick={handlePageClick}
          currentPage={currentPage}
          totalPages={totalPages}
        /> */}
      </section>
    </section>
  );
};

export default TopicDetail;
